import { MessageBox } from 'zk-ui';
import Vue from 'vue';

let isShow = false;
let rootVue = undefined;

const instance = {
  async show(messageProps = {}, options = {}) {
    if (!rootVue) {
      throw new Error('请先初始化');
    }
    if (isShow) {
      return;
    }
    isShow = true;
    try {
      const Message = await import('@/components/NoPermissionMessage');
      const h = rootVue.$createElement;
      await MessageBox({
        showClose: false,
        closeOnPressEscape: false,
        closeOnClickModal: false,
        customClass: 'zk-no-permission-alert',
        confirmButtonText: rootVue.$t('button.ok'),
        message: h(Message.default, {
          props: {
            message: rootVue.$t('permission.noPermission'),
            ...messageProps
          }
        }),
        ...options
      });
    } finally {
      isShow = false;
    }
    if (options?.toRoute !== false) {
      rootVue.$router.replace('/');
    }
  },
  hide() {
    if (!isShow) {
      return;
    }
    MessageBox.close();
  }
};

export const useNoPermissionAlert = (root) => {
  rootVue = root;
  Vue.prototype.showNoPermissionAlert = instance.show;
  Vue.prototype.hideNoPermissionAlert = instance.hide;
};

export default instance;
